<template>
    <div class="row" v-if="! showAddRecord && eduRecords && eduRecords.length > 0">
        <div class="col-lg-12">
            <div class="card shadow">
                <div class="table-responsive">
                    <base-table
                        class="table align-items-center table-flush"
                        thead-classes="thead-light"
                        tbody-classes="list"
                        :data="eduRecords"
                    >
                        <template slot="columns">
                            <th width="2%">S/N</th>
                            <th width="10%">School Type</th>
                            <th width="20%">School Name</th>
                            <th width="10%">Country</th>
                            <th width="10%">Qualifications</th>
                            <th width="10%">Start Date</th>
                            <th width="10%">End Date</th>
                            <th width="5%">&nbsp;</th>
                        </template>

                        <template
                            slot-scope="{row, index}"
                        >
                        <td class="budget">
                            {{ pagination.from+index+1}}
                        </td>
                        <td class="text-capitalize">
                            {{replaceString(row.school_type)}}
                        </td>
                        <td v-html="breakword(row.school_name)"></td>
                        <td class="text-capitalize">
                            {{row.has_country ? row.has_country.name : ''}}
                        </td>
                        <td class="text-uppercase">
                            {{row.qualifications_obtained}}
                        </td>
                        <td>
                            {{row.start_date | getDateFormat}}
                        </td>
                        <td>
                            {{row.end_date | getDateFormat}}
                        </td>
                        <td>
                            <base-button
                                type="danger" size="sm"
                                :disabled="type ? false : lock"
                                @click="$emit('deleteEduRecord', row.id)"
                            >
                                <i class="fa fa-trash"></i> Remove
                            </base-button>
                        </td>

                        </template>

                    </base-table>
                </div>

                <div
                    class="card-footer d-flex justify-content-end bg-transparent"
                    v-if="hasPagination"
                     @click="paginate"
                >
                    <base-pagination
                        :total="pagination.total"
                        align="center"
                        v-model="pagination.number"
                        :perPage="pagination.perPage"

                    >
                    </base-pagination>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'EduRecordsData',
        props: ["eduRecords", "showAddRecord", "pagination", "hasPagination", "paginate", "type"],
        filters: {
            getDateFormat(value) {
                return moment(value).format('MMM, YYYY');
            }
        },
        computed: {
            ...mapGetters(['lock'])
        },
        methods: {
            breakword(text, length = 4) {
                if(text) {
                    let splitted = text.split(' ');
                    let halfPoint = Math.ceil(splitted.length / 2);
                    let word = '';
                    for (let index = 0; index < splitted.length; index++) {
                        if((index == halfPoint) && (index >= length)) {
                            word += '<br> ' + splitted[index];
                        } else {
                            word += ' ' + splitted[index];
                        }
                    }
                    return word;
                } else {
                    return 'N/A';
                }
            },
            replaceString(value) {
                return this.replaceAll(value, '-', ' ');
            },
            replaceAll(str, find, replace) {
                return str.replace(new RegExp(find, 'g'), replace);
            }
        },
    }
</script>